import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from '@figure/frontlib-gui';

const Container = styled.div`
  margin-top: 30px;
  text-align: center;
`;

const LinkButton = ({ handleClick, children }) => (
  <Container>
    <Button type="button" secondary onClick={handleClick}>
      Connect account
    </Button>

    {children}
  </Container>
);

LinkButton.propTypes = {
  handleClick: PropTypes.func.isRequired,
  children: PropTypes.node,
};

LinkButton.defaultProps = {
  children: null,
};

export default LinkButton;
